var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.cssVars)},[(!!_vm.layout)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('div',[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }